import React from "react";
import {Button} from "@material-ui/core";
import DialogView from "src/js/components/commons/DialogView";
import {baseStyles, changeNavColor, withMediaQueries, withMultipleStyles} from "src/styles/Styles";
import auth from "src/js/utils/auth";
import {map} from "lodash";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {ImageIcon, locString} from "src/js/components/commons/ViewHelper";
import {changeLocale} from "src/js/actions/appActions";
import TextView from "src/js/components/commons/TextView";
import {FontWeightBold, FontWeightMedium} from "src/res/FontWeight";
import {ColorTheme} from "src/styles/Colors";

const useStyles = (theme) => ({
  itemView: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    minHeight: 60,
    borderBottom: '1px solid #0001',
  },
  radio: {
    width: 20,
    height: 20,
    borderRadius: 10,
    border: '2px solid '+ ColorTheme
  }
});

class LanguageDialog extends React.Component {

  constructor() {
    super();
    this.state = {
      dialogInfo: null,
      locale: null,
    }
  }

  componentDidMount() {
    const {app, classes} = this.props;
    const isLocaleSelectorDisplayed = auth.isLocaleSelectorDisplayed();
    // if (!isLocaleSelectorDisplayed) {
    //   this.showDialog({
    //     renderContent: () => {
    //       return (
    //         <div className={classes.viewColumn} style={{minWidth: 300, maxWidth: 350, minHeight: 200}}>
    //           {map(app.locale, (locale) => {
    //             const isSelected = this.state.locale && locale.value === this.state.locale.value;
    //             return (
    //               <Button
    //                 onClick={this.onLocaleSelected.bind(this, locale)}
    //                 fullWidth={true}
    //                 style={{padding: 0}}>
    //                 <div className={classes.itemView}>
    //                   <TextView fontWeight={isSelected ? FontWeightBold : FontWeightMedium} >{locale.label}</TextView>
    //                   <div className={classes.flex1}/>
    //                   {isSelected ? <ImageIcon src={require('src/images/ic_checked.png')} style={{width: 22, height: 22}} />
    //                     : <div className={classes.radio}/>
    //                   }
    //                 </div>
    //               </Button>
    //             )
    //           })}
    //         </div>
    //       );
    //     },
    //     title: locString('selectLanguage'),
    //     positiveText: locString('generic.save'),
    //     onPositiveClicked: this.onDoneClicked,
    //   });
    //   this.setState({locale: this.getSelectedLocale()});
    // } else {
    //   if (this.props.onDone) {
    //     setTimeout(() => {
    //       this.props.onDone();
    //     });
    //   }
    // }
  }

  render() {
    const {dialogInfo} = this.state;
    if (!dialogInfo) {
      return null;
    }

    return <DialogView show={true} {...dialogInfo}/>
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({dialogInfo: dialogInfo});
    }
  }

  hideDialog = () => {
    changeNavColor();
    this.setState({dialogInfo: null}, () => {
      if (this.props.onDone) {
        this.props.onDone();
      }
    });
  };

  getSelectedLocale() {
    const {app} = this.props;
    let selectedLocale = null;
    app.locale.forEach((locale) => {
      if (locale.value === app.defaultLocale) {
        selectedLocale = locale;
      }
    });
    return selectedLocale;
  }

  onLocaleSelected = (locale) => {
    this.setState({locale: locale});
  }

  onDoneClicked = () => {
    this.hideDialog();
    auth.setLocaleSelectorDisplayed();
    const lastLocale = this.getSelectedLocale();
    if (!lastLocale || lastLocale.value !== this.state.locale.value) {
      this.props.changeLocale(this.state.locale);
    }
  };
}

LanguageDialog.propTypes = {
  classes: PropTypes.object,
  app: PropTypes.object,
};

LanguageDialog.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    changeLocale: (locale) => dispatch(changeLocale(locale)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
    ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
  ])(LanguageDialog))
);
